import React, { useCallback, useMemo } from 'react';
import './CustomDropDownPersonal.css';

interface DescriptionBlock {
  title: string;
  descr: string;
}

interface AccordionItem {
  number: string;
  title: string;
  description?: string;
  descriptionsBlock1?: DescriptionBlock;
  descriptionsBlock2?: DescriptionBlock;
  descriptionsBlock3?: DescriptionBlock;
  descriptionsBlock4?: DescriptionBlock;
}

const CustomDropDownPersonal = () => {
  const [activeIndex, setActiveIndex] = React.useState<number | null>(0);

  const items: AccordionItem[] = useMemo(() => [
    {
      number: "01",
      title: "Multi-Currency Bank Accounts (MCA)",
      descriptionsBlock1: {
        title: '01',
        descr: 'Fully regulated accounts securing crypto and fiat assets'
      },
      descriptionsBlock2: {
        title: '02',
        descr: 'Conversions between selected USD stablecoins and fiat USD'
      },
      descriptionsBlock3: {
        title: '03',
        descr: 'Bitcoin supported as a transactional currency'
      },
      descriptionsBlock4: {
        title: '04',
        descr: 'Professional payment transaction management'
      }
    },
    {
      number: "02", 
      title: "OTC Crypto Trading",
      descriptionsBlock1: {
        title: "01",
        descr: 'Spot trading of major cryptocurrencies'
      },
      descriptionsBlock2: {
        title: "02",
        descr: 'Real-time quotes via our trading desk'
      },
      descriptionsBlock3: {
        title: "03",
        descr: 'Settlements processed through your MCA'
      },
    },
    {
      number: "03",
      title: "Escrow Services",
      descriptionsBlock1: {
        title: "01",
        descr: 'Trusted intermediary for third-party OTC fiat-crypto transactions'
      },
      descriptionsBlock2: {
        title: "02",
        descr: 'Both parties onboarded with MCAs; escrow released instantly upon blockchain confirmation'
      },
    },
   
  ], []);

  const toggleItem = useCallback((index: number) => {
    setActiveIndex(prevIndex => prevIndex === index ? null : index);
  }, []);

  const renderDescriptionBlocks = useCallback((item: AccordionItem) => {
    const blocks = [
      item.descriptionsBlock1,
      item.descriptionsBlock2, 
      item.descriptionsBlock3,
      item.descriptionsBlock4
    ].filter(Boolean) as DescriptionBlock[];

    if (blocks.length === 0 && !item.description) return null;

    return (
      <div className="mca-accordion__content_row">
        {blocks.map((block, blockIndex) => (
          <div key={blockIndex} className="item_content_block">
            <h3 className="item_block_title">{block.title}</h3>
            <p className="item_descr">{block.descr}</p>
          </div>
        ))}
        {item.description && (
          <p className="mca-accordion__description">{item.description}</p>
        )}
      </div>
    );
  }, []);

  return (
    <div className="mca-accordion">
      
      
      <div className="mca-accordion__items">
        {items.map((item, index) => (
          <div 
            key={item.number}
            className={`mca-accordion__item ${activeIndex === index ? 'active' : ''}`}
            onClick={() => toggleItem(index)}
          >
            <div className="mca-accordion__header">
              <h3 className="mca-accordion__item-title">{item.title}</h3>
              <div className="mca-accordion__icon">
                <span className={`mca-accordion__arrow ${activeIndex === index ? 'active' : ''}`}></span>
              </div>
            </div>
            
            {activeIndex === index && renderDescriptionBlocks(item)}
          </div>
        ))}
      </div>
    </div>
  );
};

export default CustomDropDownPersonal;